import { defaultMST3020_R01DetailDto } from "./Dto_MST3020_R01";
import { useMST3020_R01Store } from "./Store_MST3020_R01";
import { ImageForm } from "src/components/common/form/ImageForm";
import { showWarning } from "src/utils/toast/toastUtil";



// Base64 문자열로 전달되는 작업표준서 이미지의 최대 허용 크기입니다.
const MAX_MST3020_R01_IMAGE_SIZE = 10 * 1024 * 1024;

/** Base64 패딩을 제외한 실제 바이트 크기를 계산해 10MB 초과 여부를 검사합니다. */
const validateMST3020_R01ImageSize = (base64Image: string) => {
	if (!base64Image) {
		return true;
	}
	const paddingSize = base64Image.endsWith('==') ? 2 : base64Image.endsWith('=') ? 1 : 0;
	const imageSize = Math.floor(base64Image.length * 3 / 4) - paddingSize;
	if (imageSize > MAX_MST3020_R01_IMAGE_SIZE) {
		showWarning('이미지 크기는 10MB를 초과할 수 없습니다.');
		return false;
	}
	return true;
};

export const Info_MST3020_R01 = () => {

	const {
		editMST3020_R01Detail, setEditMST3020_R01Detail,
	} = useMST3020_R01Store();

	// 두 이미지 박스는 같은 너비를 사용하고 이미지 영역의 남은 높이를 모두 채웁니다.
	const itemImageWrapperStyle = {
		wrapperStyle: "flex-1 min-w-0 h-full",
	}
	return (
		<div className="w-full h-full flex flex-col gap-[4px]">
			<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
				<div className="w-full h-full flex flex-col gap-[12px] pt-[12px]">
					{/* 선택한 작업표준 상세행의 공정 및 입고창고 정보 */}
					<div className="w-full shrink-0">
						<div>공정명 : {editMST3020_R01Detail?.workplaceNm}</div>
						<div>입고창고명 : {editMST3020_R01Detail?.warehouseNm}</div>
					</div>
					{/*
						두 작업표준서 영역을 한 행에 1/2씩 배치합니다.
						최소 높이는 250px이며 상세 영역이 커지면 남은 높이만큼 함께 확장됩니다.
					*/}
					<div className="w-full flex-1 min-h-[250px] flex flex-nowrap gap-[12px] min-w-0">
						<ImageForm
                            title="작업표준서1"
                            image={editMST3020_R01Detail?.standardSheet || ''}
                            onImageChange={(standardSheet) => {
							if (!validateMST3020_R01ImageSize(standardSheet)) return;
							setEditMST3020_R01Detail({ ...(editMST3020_R01Detail ?? defaultMST3020_R01DetailDto), standardSheet });	}}
                            wrapperOption={itemImageWrapperStyle}
                            previewEnabled
                        />
						<ImageForm
                            title="작업표준서2"
                            image={editMST3020_R01Detail?.standardSheet2 || ''}
                            onImageChange={(standardSheet2) => {
							if (!validateMST3020_R01ImageSize(standardSheet2)) return;
							setEditMST3020_R01Detail({ ...(editMST3020_R01Detail ?? defaultMST3020_R01DetailDto), standardSheet2 });	}}
                            wrapperOption={itemImageWrapperStyle}
                            previewEnabled
                        />
					</div>
				</div>
			</div>
		</div>
	)
}
